export default __webpack_public_path__ + "static/media/criminal5.aca7bb96.jpg";